import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// import { loadRemoteModule } from '@nrwl/angular/mf';

import { ShellComponent } from './shell/shell.component';

const routes: Routes = [
  {
    path: '',
    component: ShellComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            '@digital-platform/rs-sustainability/feature-sustainability'
          ).then((m) => m.RsSustainabilityFeatureSustainabilityModule),
      },
      {
        path: 'component-playground',
        loadChildren: () =>
          import(
            '@digital-platform/rs-sustainability/component-playground'
          ).then((m) => m.RsSustainabilityComponentPlaygroundModule),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RsSustainabilityShellRoutingModule {}
